export default {
  // Navigation
  'nav.about': 'Hakkımızda',
  'nav.services': 'Hizmetler',
  'nav.approach': 'Yaklaşımımız',
  'nav.cases': 'Vaka Çalışmaları',
  'nav.team': 'Ekip',
  'nav.contacts': 'İletişim',
  
  // Hero Section
  'hero.title': 'Sistematik Pazarlama ve Yapay Zeka: İstikrarlı Satış Büyümesinin Anahtarınız',
  'hero.subtitle': 'Kaosu sisteme dönüştürüyoruz. İşinizi ölçeklendirmek için uzman deneyimini AI algoritmalarının hassasiyetiyle birleştiriyoruz.',
  'hero.cta1': 'Büyüme Stratejisi Alın',
  'hero.cta2': 'Projeyi Görüşün',
  'hero.formTitle': 'Pazarlamanız %100 çalışıyor mu yoksa bütçenizi mi tüketiyor?',
  'hero.formSubtitle': 'Tahmin etmeyin. Dışarıdan dürüst bir bakış açısı edinin. Projenizin ücretsiz 20 dakikalık hızlı tanısı için kaydolun.',
  'hero.formBenefitsTitle': 'Öğrenecekleriniz:',
  'hero.formBenefit1': 'Şu anda müşterileri nerede kaybettiğiniz (hunideki "delikleri" bulma)',
  'hero.formBenefit2': 'Geliri ölçeklendirmek için 3 açık olmayan büyüme noktası',
  'hero.formBenefit3': 'AI\'ın reklam maliyetlerinizi nasıl azaltabileceği',
  'hero.formName': 'İsim',
  'hero.formPhone': 'Telefon',
  'hero.formWebsite': 'Web sitesi bağlantısı',
  'hero.formWebsiteOptional': '(isteğe bağlı)',
  'hero.formSubmit': 'Tanı için kaydolun',
  'hero.formPrivacy': 'Butona tıklayarak gizlilik politikasını kabul ediyorsunuz',
  'hero.formSuccess': 'Başvuru gönderildi! En kısa sürede sizinle iletişime geçeceğiz.',
  'hero.formError': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  
  // Pain Points
  'pain.title': 'Tanıdık Durum mu?',
  'pain.point1.title': 'Serbest çalışanları tek tek işe alıyorsunuz',
  'pain.point1.desc': 've asla gerçekleşmeyen bir mucize mi bekliyorsunuz?',
  'pain.point2.title': 'Bütçeleri tüketiyorsunuz',
  'pain.point2.desc': 'Yandex ve Google\'da görünür sonuç olmadan mı?',
  'pain.point3.title': 'Bir his var',
  'pain.point3.desc': '"Bir şeyleri yanlış yapıyorum" ama nasıl düzelteceğinizi bilmiyorsunuz?',
  'pain.conclusion': 'Sistem olmadan kaotik eylemler sadece zaman ve para kaybına yol açar',
  
  // Solution
  'solution.title': 'Sistematik Pazarlama Nedir?',
  'solution.subtitle': 'İstikrarlı büyüme ve satışların anahtarınız',
  'solution.problemTitle': 'Pazarlama Kaosu — Kârınızın Düşmanı',
  'solution.problemDesc': 'Çoğu şirket "pazarlama kaosu" durumunda yaşıyor: nokta reklam lansmanları, yüklenici değişiklikleri, hangi rublenin kâr getirdiğini ve hangisinin boşa harcandığını anlayamama.',
  'solution.defTitle': 'Sistematik Pazarlama — kaosun karşıtı',
  'solution.defDesc1': 'Bu, pazarlamanın dağınık eylemler dizisi (Direct başlattık, gönderi yazdık) olarak değil, öngörülebilir finansal sonuç için çalışan tek bir organizma olarak görüldüğü bir yaklaşımdır.',
  'solution.defDesc2': 'Bu, tıklamaları gerçek, sadık müşterilere dönüştüren ve yatırılan her rublenin ölçülebilir kâr getirdiği temeldir.',
  'solution.pillarsTitle': 'Sistematik Pazarlamanın Üç Direği',
  'solution.pillarsSubtitle': 'Üç unsurun birliği',
  'solution.pillarsDesc': 'Sistematik pazarlama, tek bir mekanizma olarak çalışan üç temel bileşenin sinerjisine dayanır',
  
  // Services
  'services.title': 'Hizmetlerimiz',
  'services.subtitle': 'Hazır bir çözüm seçin veya işiniz için özel bir strateji oluşturalım',
  'services.cta': 'Hizmet maliyetini hesaplayın',
  
  // How We Work
  'howWeWork.title': 'Nasıl Çalışıyoruz',
  'howWeWork.subtitle': 'Sistem kurmanın 5 aşaması — pazarlamanızı dönüştürmenin adım adım süreci',
  
  // Case Studies
  'cases.title': '💼 Vaka Çalışmaları: Sistem Pratikte Nasıl Çalışır',
  'cases.subtitle': 'Sonuçları gizlemiyoruz. İşte strateji ve uçtan uca analitiğin uygulanmasının gerçek zamanlı geliri nasıl etkilediğine dair örnekler.',
  
  // Why Us
  'whyUs.title': 'Neden Biz?',
  'whyUs.subtitle': 'Biz stratejik ortağınızız, sadece bir yüklenici değil',
  'whyUs.reason1.title': 'AI Tabanlı Garanti',
  'whyUs.reason1.desc': 'Harcamaları tahminlere değil, doğru modellere dayandırıyoruz. Yapay zeka, optimal kararlar almak için milyonlarca veriyi analiz eder.',
  'whyUs.reason2.title': 'Gizli Silah',
  'whyUs.reason2.desc': 'Rakiplerinizde olmayan teknolojiler. Tahmin ve otomasyon için en son AI araçlarını kullanıyoruz.',
  'whyUs.reason3.title': 'Zamanınız Değerlidir',
  'whyUs.reason3.desc': 'Rutin işleri biz üstleniyoruz, siz işinizle ilgilenin. Tam süreç otomasyonu, kaynaklarınızı stratejik gelişim için serbest bırakır.',
  
  // Results
  'results.title': 'Sistem Uygulandıktan Sonra Ne Elde Edeceksiniz?',
  'results.subtitle': 'İşinizi değiştirecek somut sonuçlar',
  
  // About
  'about.title': 'En İyi Uzmandan Kurucuya Evrim',
  'about.subtitle': 'Sezgisel pazarlamaya inanmıyoruz. Veri doğruluğuna, psikoloji derinliğine ve algoritma hızına inanıyoruz.',
  
  // Lead Form
  'leadForm.title': 'Kaosu İstikrarlı Büyümeye Dönüştürmeye Hazır mısınız?',
  'leadForm.subtitle': 'Pazarlamanızın ücretsiz tanısı için başvuru bırakın. AI analizi kullanarak büyüme noktalarını göstereceğiz.',
  'leadForm.name': 'Adınız',
  'leadForm.phone': 'Telefon',
  'leadForm.website': 'Web sitesi',
  'leadForm.websiteOptional': '(isteğe bağlı)',
  'leadForm.messenger': 'Tercih edilen mesajlaşma uygulaması',
  'leadForm.messengerPlaceholder': 'Mesajlaşma uygulaması seçin',
  'leadForm.telegram': 'Telegram',
  'leadForm.whatsapp': 'WhatsApp',
  'leadForm.phoneCall': 'Telefon araması',
  'leadForm.submit': 'Tanı için kaydolun',
  'leadForm.success': '✓ Başvuru gönderildi! En kısa sürede sizinle iletişime geçeceğiz.',
  'leadForm.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'leadForm.privacy': 'Butona tıklayarak gizlilik politikasını kabul ediyorsunuz',
  
  // Footer
  'footer.company': 'Sistematik Pazarlama',
  'footer.description': 'Kaosu sisteme dönüştürüyoruz. Uzman deneyimini AI algoritmalarının hassasiyetiyle birleştiriyoruz.',
  'footer.services': 'Hizmetler',
  'footer.company.title': 'Şirket',
  'footer.contacts': 'İletişim',
  'footer.address': '109202, Moskova, 2. Karacharovskaya Cad., Bina 1, Yapı 1, Oda 6/2',
  'footer.rights': 'Sistematik Pazarlama. Tüm hakları saklıdır.',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  
  // Common
  'common.readMore': 'Devamını Oku',
  'common.contactUs': 'Bizimle İletişime Geçin',
  'common.learnMore': 'Daha Fazla Bilgi',
  'common.loading': 'Yükleniyor...',
  'common.submit': 'Gönder',
  'common.cancel': 'İptal',
  'common.close': 'Kapat',
};
